import cx from 'classnames';
import { HeaderCell } from '../Cells';

export const DesktopTHead = ({ headerOptions, sortModel, className, headerRef }) => {
  if (!headerOptions) {
    return null;
  }

  return (
    <thead className={cx('custom-table__thead', { [className]: !!className })} ref={headerRef}>
      <tr>
        {headerOptions.map((cell, index) => (
          <HeaderCell key={index} cell={cell} sortModel={sortModel} />
        ))}
      </tr>
    </thead>
  );
};
